// removed by extract-text-webpack-plugin
module.exports = {"event-details-modal":"event-details-modal","modal-body":"modal-body","event-details":"event-details"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/event-details-modal/event-details-modal.style.sass
// module id = vGwf
// module chunks = 0